import { b, contactStep } from './helpers'

// Cada flujo corresponde a un "motivo" (state de <Link to="/contact" state="...">).
// Paso: type (choice | multi | text | number | contact), text, hint, icon, video, image, options, next.
// video/image: rutas en /public (ej. '/videos/retail.mp4'). Sin ellos se muestra el icono.

const sectorOptions = (next) => [
  { value: 'retail', label: b('Retail / tiendas', 'Retail / stores'), next, echo: b('Retail: precisión de inventario y cero quiebres.', 'Retail: inventory accuracy and no stock-outs.') },
  { value: 'almacen', label: b('Almacén / logística', 'Warehouse / logistics'), next, echo: b('Almacenes: velocidad en recepción y surtido.', 'Warehouses: faster receiving and picking.') },
  { value: 'manufactura', label: b('Manufactura', 'Manufacturing'), next, echo: b('Manufactura: trazabilidad de punta a punta.', 'Manufacturing: end-to-end traceability.') },
  { value: 'otro', label: b('Otro sector', 'Other industry'), next },
]

export const general = {
  id: 'general',
  title: b('Contacto', 'Contact'),
  start: 'asunto',
  submit: { formName: 'contacto', motivo: b('Contacto general', 'General inquiry') },
  steps: {
    asunto: {
      type: 'choice',
      text: b('¿En qué podemos ayudarte?', 'How can we help you?'),
      hint: b('Elige una opción y te hacemos las preguntas justas.', 'Pick one and we will ask only what matters.'),
      icon: 'chat',
      options: [
        { value: 'cotizar-equipo', label: b('Cotizar equipo', 'Quote equipment'), flow: 'cotizar-equipo' },
        { value: 'cotizar-reparacion', label: b('Cotizar una reparación', 'Quote a repair'), flow: 'cotizar-reparacion' },
        { value: 'mantenimiento', label: b('Mantenimiento', 'Maintenance'), flow: 'mantenimiento' },
        { value: 'demo-rfid', label: b('Demo de RFID', 'RFID demo'), flow: 'demo-rfid' },
        { value: 'demo-swrya', label: b('Demo de SWRYA', 'SWRYA demo'), flow: 'demo-swrya' },
        { value: 'otro', label: b('Otra consulta', 'Something else'), next: 'mensaje' },
      ],
    },
    mensaje: {
      type: 'text',
      text: b('Cuéntanos qué necesitas', 'Tell us what you need'),
      icon: 'chat',
      required: true,
      next: 'contacto',
    },
    contacto: contactStep,
  },
}

export const cotizarEquipo = {
  id: 'cotizar-equipo',
  title: b('Cotizar equipo', 'Quote equipment'),
  start: 'equipo',
  submit: { formName: 'contacto', motivo: b('Cotizar equipo', 'Quote equipment') },
  steps: {
    equipo: {
      type: 'multi',
      text: b('¿Qué equipo te interesa?', 'What equipment are you interested in?'),
      hint: b('Puedes elegir varios.', 'You can pick several.'),
      icon: 'device',
      options: [
        { value: 'terminales', label: b('Terminales móviles', 'Mobile computers') },
        { value: 'impresoras', label: b('Impresoras de etiquetas', 'Label printers') },
        { value: 'lectores-rfid', label: b('Lectores RFID', 'RFID readers') },
        { value: 'consumibles', label: b('Etiquetas y consumibles', 'Labels & supplies') },
      ],
      next: 'sector',
      echo: b('Anotado.', 'Noted.'),
    },
    sector: { type: 'choice', text: b('¿En qué sector operas?', 'Which industry are you in?'), icon: 'building', options: sectorOptions('cantidad') },
    cantidad: {
      type: 'choice',
      text: b('¿Cuántas piezas necesitas aproximadamente?', 'Roughly how many units do you need?'),
      icon: 'chart',
      options: [
        { value: '1-5', label: b('1 a 5', '1 to 5'), next: 'contacto' },
        { value: '6-25', label: b('6 a 25', '6 to 25'), next: 'contacto' },
        { value: '25+', label: b('Más de 25', 'More than 25'), next: 'proyecto', echo: b('Para volumen armamos una propuesta a la medida.', 'For volume we build a tailored proposal.') },
      ],
    },
    proyecto: {
      type: 'text',
      text: b('¿Es para un proyecto o despliegue nuevo? Cuéntanos.', 'Is this for a new project or rollout? Tell us about it.'),
      icon: 'chart',
      next: 'contacto',
    },
    contacto: contactStep,
  },
}

export const cotizarReparacion = {
  id: 'cotizar-reparacion',
  title: b('Cotizar reparación', 'Quote a repair'),
  start: 'equipo',
  submit: { formName: 'contacto', motivo: b('Cotizar reparación', 'Quote a repair') },
  steps: {
    equipo: {
      type: 'choice',
      text: b('¿Qué equipo necesita reparación?', 'Which device needs repair?'),
      icon: 'wrench',
      options: [
        { value: 'terminal', label: b('Terminal móvil', 'Mobile computer'), next: 'falla' },
        { value: 'impresora', label: b('Impresora', 'Printer'), next: 'falla' },
        { value: 'lector', label: b('Lector / escáner', 'Reader / scanner'), next: 'falla' },
        { value: 'otro', label: b('Otro', 'Other'), next: 'falla' },
      ],
    },
    falla: {
      type: 'choice',
      text: b('¿Qué está pasando con el equipo?', 'What is happening with the device?'),
      hint: b('Con esto el técnico llega con diagnóstico previo.', 'So the technician starts with a preliminary diagnosis.'),
      icon: 'wrench',
      options: [
        { value: 'no-enciende', label: b('No enciende', 'Does not power on'), next: 'modelo', echo: b('Suele ser batería o tarjeta de carga; lo revisamos.', 'Often battery or charge board; we will check it.') },
        { value: 'pantalla', label: b('Pantalla o táctil dañado', 'Screen or touch damaged'), next: 'modelo' },
        { value: 'lectura', label: b('No lee o imprime mal', 'Fails to scan or prints badly'), next: 'modelo' },
        { value: 'otra', label: b('Otra falla', 'Other issue'), next: 'modelo' },
      ],
    },
    modelo: {
      type: 'text',
      text: b('Modelo y número de serie (si los tienes)', 'Model and serial number (if you have them)'),
      hint: b('Los encuentras en la etiqueta trasera del equipo.', 'You can find them on the back label.'),
      icon: 'device',
      placeholder: b('Ej. TC52 / S/N 12345', 'E.g. TC52 / S/N 12345'),
      next: 'urgencia',
    },
    urgencia: {
      type: 'choice',
      text: b('¿Qué tan urgente es?', 'How urgent is it?'),
      icon: 'clock',
      options: [
        { value: 'urgente', label: b('Me detiene la operación', 'It is stopping operations'), next: 'contacto', echo: b('Entendido, lo priorizamos.', 'Understood, we will prioritize it.') },
        { value: 'normal', label: b('Puede esperar unos días', 'It can wait a few days'), next: 'contacto' },
      ],
    },
    contacto: contactStep,
  },
}

export const mantenimiento = {
  id: 'mantenimiento',
  title: b('Mantenimiento', 'Maintenance'),
  start: 'equipos',
  submit: { formName: 'contacto', motivo: b('Mantenimiento', 'Maintenance') },
  steps: {
    equipos: {
      type: 'multi',
      text: b('¿Qué equipos quieres mantener?', 'Which equipment do you want maintained?'),
      icon: 'shield',
      options: [
        { value: 'terminales', label: b('Terminales móviles', 'Mobile computers') },
        { value: 'impresoras', label: b('Impresoras', 'Printers') },
        { value: 'lectores', label: b('Lectores RFID / escáneres', 'RFID readers / scanners') },
      ],
      next: 'cantidad',
    },
    cantidad: {
      type: 'choice',
      text: b('¿Cuántos equipos son en total?', 'How many devices in total?'),
      icon: 'chart',
      options: [
        { value: '1-10', label: b('1 a 10', '1 to 10'), next: 'tipo' },
        { value: '11-50', label: b('11 a 50', '11 to 50'), next: 'tipo' },
        { value: '50+', label: b('Más de 50', 'More than 50'), next: 'tipo', echo: b('Con esa flota conviene una póliza.', 'With that fleet a service plan makes sense.') },
      ],
    },
    tipo: {
      type: 'choice',
      text: b('¿Qué esquema te interesa?', 'Which scheme interests you?'),
      icon: 'shield',
      options: [
        { value: 'preventivo', label: b('Preventivo programado', 'Scheduled preventive'), next: 'contacto' },
        { value: 'correctivo', label: b('Correctivo cuando falle', 'Corrective on failure'), next: 'contacto' },
        { value: 'poliza', label: b('Póliza anual todo incluido', 'All-inclusive annual plan'), next: 'contacto' },
        { value: 'asesoria', label: b('Aún no sé, necesito asesoría', 'Not sure yet, I need advice'), next: 'contacto', echo: b('Sin problema, te orientamos.', 'No problem, we will guide you.') },
      ],
    },
    contacto: contactStep,
  },
}

export const demoRfid = {
  id: 'demo-rfid',
  title: b('Demo de RFID', 'RFID demo'),
  start: 'sector',
  submit: { formName: 'contacto', motivo: b('Demo de RFID', 'RFID demo') },
  steps: {
    sector: { type: 'choice', text: b('¿En qué sector operas?', 'Which industry are you in?'), icon: 'building', options: sectorOptions('objetivo') },
    objetivo: {
      type: 'choice',
      text: b('¿Qué quieres lograr con RFID?', 'What do you want to achieve with RFID?'),
      icon: 'signal',
      options: [
        { value: 'inventario', label: b('Inventarios exactos y rápidos', 'Fast, accurate inventories'), next: 'sitios', echo: b('Un conteo completo en minutos, no en días.', 'A full count in minutes, not days.') },
        { value: 'trazabilidad', label: b('Trazabilidad de producto', 'Product traceability'), next: 'sitios' },
        { value: 'perdidas', label: b('Reducir mermas y robo', 'Reduce shrinkage and theft'), next: 'sitios' },
        { value: 'explorar', label: b('Solo explorar', 'Just exploring'), next: 'sitios' },
      ],
    },
    sitios: {
      type: 'number',
      text: b('¿Cuántas ubicaciones (tiendas, almacenes, plantas) tienen?', 'How many locations (stores, warehouses, plants) do you have?'),
      icon: 'building',
      placeholder: b('Ej. 12', 'E.g. 12'),
      echo: b('Con eso dimensionamos la demo.', 'That helps us size the demo.'),
      next: 'contacto',
    },
    contacto: contactStep,
  },
}

export const demoSwrya = {
  id: 'demo-swrya',
  title: b('Demo de SWRYA', 'SWRYA demo'),
  start: 'modulos',
  submit: { formName: 'contacto', motivo: b('Demo de SWRYA', 'SWRYA demo') },
  steps: {
    modulos: {
      type: 'multi',
      text: b('¿Qué quieres controlar con SWRYA?', 'What do you want to control with SWRYA?'),
      hint: b('Elige todo lo que aplique.', 'Pick everything that applies.'),
      icon: 'chart',
      options: [
        { value: 'inventarios', label: b('Inventarios y conteos', 'Inventory and counts') },
        { value: 'auditorias', label: b('Auditorías', 'Audits') },
        { value: 'activos', label: b('Activos y equipos', 'Assets and equipment') },
        { value: 'reportes', label: b('Reportes en tiempo real', 'Real-time reporting') },
      ],
      next: 'hoy',
    },
    hoy: {
      type: 'choice',
      text: b('¿Cómo lo manejan hoy?', 'How do you handle it today?'),
      icon: 'document',
      options: [
        { value: 'excel', label: b('Excel / papel', 'Excel / paper'), next: 'sucursales', echo: b('Es el punto de partida más común.', 'That is the most common starting point.') },
        { value: 'erp', label: b('Un ERP o sistema propio', 'An ERP or in-house system'), next: 'sucursales' },
        { value: 'nada', label: b('Aún no lo controlamos', 'We do not track it yet'), next: 'sucursales' },
      ],
    },
    sucursales: {
      type: 'number',
      text: b('¿Cuántas sucursales o sitios?', 'How many branches or sites?'),
      icon: 'building',
      placeholder: b('Ej. 8', 'E.g. 8'),
      next: 'contacto',
    },
    contacto: contactStep,
  },
}

export const contactFlows = {
  general,
  'cotizar-equipo': cotizarEquipo,
  'cotizar-reparacion': cotizarReparacion,
  mantenimiento,
  'demo-rfid': demoRfid,
  'demo-swrya': demoSwrya,
}
